import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';

import { BaseWidget } from '@website-builder/widgets/base/base-widget';
import { MenuConfig } from '@website-builder/widgets/menu/model/menu-config';
import { MenuSection } from '@website-builder/widgets/menu/model/menu-section';
import { MenuStyle } from '@website-builder/widgets/menu/model/menu-style';
import { BaseWidgetNormalizer } from '@website-builder/widgets/normalizer/base-widget-normalizer';

export class MenuWidget extends BaseWidget<MenuStyle> {
  readonly type = BuilderElementType.Menu;
  style = new MenuStyle();
  menuSections = [new MenuSection()];
  config = new MenuConfig();

  static normalizeInPlace(widget: MenuWidget): MenuWidget {
    const pureWidget = new MenuWidget();

    BaseWidgetNormalizer.normalizeInPlace(widget, pureWidget);

    widget.menuSections = widget.menuSections ?? pureWidget.menuSections;
    widget.config = widget.config ?? pureWidget.config;

    widget.style = MenuStyle.normalize(widget.style);

    return widget;
  }
}
